import { Card, CardHeader, CardContent, List, Typography, LinearProgress, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import * as Icons from '@mui/icons-material'
import _ from 'lodash'
import { useOrgContext } from '~/common/context/organization/org-context'
import { useCropData } from './use-crop-data'

const appendStringIfPlural = (arr) => {
  return arr.length === 1 ? '' : 's'
}

export const CropInfoCard = () => {
  const { activeOrgs } = useOrgContext()
  const latestActiveOrg = _.last(activeOrgs)
  const { crops, loading, error } = useCropData({
    orgId: latestActiveOrg?.id,
    orgType: latestActiveOrg?.organization_type
  })

  const totalPlants =  crops.reduce((sum, crop) => sum + crop.count, 0)
  const title = `Crops in ${latestActiveOrg?.name || ''}`

  // Error handling
  if (error) {
    return (
      <Card>
        <CardHeader title={title} />
        <CardContent>
          <Typography color="error">Error loading crops: {error}</Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={title}
        subheader={
          `${crops.length} crop${appendStringIfPlural(crops)} | ${totalPlants} plant${appendStringIfPlural([...Array(totalPlants)])}`
        }
        sx={{
          p: 1.5,
          pb: 1,
          borderBottom: '1px solid gray',
          flexShrink: 0
        }}
      />
      <CardContent
        sx={{
          p: 0,
          flex: 1,
          overflow: 'auto',
          minHeight: 0,
          '&.MuiCardContent-root:last-child': {
            pb: 0,
          }
        }}
      >
        {loading ? <LinearProgress /> : (
          <List sx={{ py: 0 }}>
            {crops.map(crop => {
              const varietyName = crop.template_crop_varieties?.name
              const speciesName = crop.template_crop_species?.name
              const displayName = varietyName || speciesName || 'Generic crop'

              return (
                <Accordion
                  key={crop.id}
                  disableGutters
                  elevation={0}
                  sx={{
                    '&:before': { display: 'none' },
                    borderBottom: '1px solid',
                    borderColor: 'divider'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<Icons.ExpandMore />}
                    sx={{ minHeight: 40, py: 0 }}
                  >
                    <Typography variant='body1' sx={{ flex: 1 }}>
                      {displayName}
                    </Typography>
                    <Typography variant='body2' color='text.secondary' sx={{ mr: 1 }}>
                      {crop.count}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                    <Typography variant='body2' color='text.secondary'>
                      {crop.notes || 'No notes'}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              )
            })}
          </List>
        )}
      </CardContent>
    </Card>
  )
}
